import React from "react";
import styled from "@emotion/styled";
import useAIDTMediaQuery from "../../hooks/useAIDTMediaQuery";
import { ArrowLeft, ArrowRight } from "../../icons";

interface PaginationButtonProps {
  left?: boolean;
  right?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  size?: number;
}

const Button = styled.button<{ disabled: boolean, isTablet: boolean, size?: number }>`
  width: ${({ size }) => size ? `${size}px` : "60px"};
  height: ${({ size }) => size ? `${size}px` : "60px"};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  pointer-events: auto;
  background-color: ${({ disabled }) => (disabled ? "#ddd" : "#fff")};
  border-radius: 40px;
  box-shadow:  ${({ isTablet }) => (isTablet ? "none" : "0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 8px 10px 0px rgba(0, 0, 0, 0.05), 0px 8px 30px 0px rgba(0, 0, 0, 0.12)")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:hover {
    background-color: ${({ disabled, isTablet }) => isTablet ? (disabled ? "#ddd" : "#e0e0e0") : "none"};
  }
`;

const PaginationButton: React.FC<PaginationButtonProps> = ({ left, right, onClick, disabled = false, size }) => {
  const { isTablet } = useAIDTMediaQuery();
  return (
    <Button onClick={onClick} disabled={disabled} isTablet={isTablet} size={size}>
      {left && <ArrowLeft size={size} />}
      {right && <ArrowRight size={size} />}
    </Button>
  );
};

export default PaginationButton;
